"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jobQueue = [];
var isJobProcessing = false;
function invokeJob(interval) {
    var job = jobQueue.shift();
    job && job();
    setTimeout(function () {
        if (jobQueue.length) {
            invokeJob(interval);
        }
        else {
            isJobProcessing = false;
        }
    }, interval);
}
function nextTick(job, interval) {
    if (interval === void 0) { interval = 100; }
    jobQueue.push(job);
    if (!isJobProcessing) {
        isJobProcessing = true;
        invokeJob(interval);
    }
}
exports.nextTick = nextTick;
